import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21e0b4cd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=21e0b4cd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0b4cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e0b4cd')) {
      api.createRecord('21e0b4cd', component.options)
    } else {
      api.reload('21e0b4cd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21e0b4cd&scoped=true", function () {
      api.rerender('21e0b4cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JsonKeyValuePanel/index.vue"
export default component.exports